'use client';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Icon from '@/components/ui/AppIcon';

interface EmailForm {
  email: string;
}

export default function EmailSignup() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm<EmailForm>();

  const onSubmit = async (data: EmailForm) => {
    setLoading(true);
    // TODO: Backend integration — POST /api/newsletter/subscribe with { email: data.email }
    await new Promise((r) => setTimeout(r, 1000));
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <section className="py-20 bg-primary-500">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="max-w-2xl mx-auto text-center">
          <Icon name="EnvelopeIcon" size={40} className="text-primary-200 mx-auto mb-4" />
          <h2 className="font-display text-3xl font-bold text-white mb-3">
            New Lessons Every Month
          </h2>
          <p className="text-primary-100 text-base mb-8">
            Get new global citizenship lessons, teaching tips, and SDG activity ideas delivered
            to your inbox. Join 12,400+ educators already subscribed.
          </p>

          {submitted ? (
            <div className="flex items-center justify-center gap-3 bg-white/20 rounded-2xl px-6 py-4 text-white">
              <Icon name="CheckCircleIcon" size={20} />
              <span className="font-medium">You're in! Check your inbox for a welcome gift.</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col sm:flex-row gap-3">
              <div className="flex-1">
                <input
                  {...register('email', {
                    required: 'Email is required',
                    pattern: { value: /^\S+@\S+\.\S+$/, message: 'Enter a valid email' },
                  })}
                  type="email"
                  placeholder="your@school.edu"
                  className="w-full px-4 py-3.5 rounded-xl text-stone-800 text-sm placeholder:text-stone-400 bg-white border border-transparent focus:outline-none focus:ring-2 focus:ring-white/50"
                />
                {errors.email && (
                  <p className="text-red-200 text-xs mt-1.5 text-left">{errors.email.message}</p>
                )}
              </div>
              <button
                type="submit"
                disabled={loading}
                className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl text-sm font-semibold text-primary-700 bg-white hover:bg-primary-50 active:scale-95 disabled:opacity-70 transition-all duration-150 whitespace-nowrap"
                style={{ minWidth: '160px' }}
              >
                {loading ? (
                  <>
                    <Icon name="ArrowPathIcon" size={16} className="animate-spin" />
                    Subscribing...
                  </>
                ) : (
                  <>
                    <Icon name="PaperAirplaneIcon" size={16} />
                    Subscribe Free
                  </>
                )}
              </button>
            </form>
          )}

          <p className="text-primary-200 text-xs mt-4">
            No spam. Unsubscribe anytime. Your data is protected.
          </p>
        </div>
      </div>
    </section>
  );
}